import { render } from "./Gallery.vue?vue&type=template&id=0f996a6c&scoped=true&ts=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"

import "./Gallery.vue?vue&type=style&index=0&id=0f996a6c&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f996a6c"]])

export default __exports__